import * as yup from "yup";
import find from "lodash/find";

export const subscriptionTypes = {
	product: "PRODUCT",
	collection: "COLLECTION",
	wineClub: "WINE_CLUB",
};

export const frequencyTypes = {
	yearly: "YEARLY",
	twice_a_year: "TWICE_YEARLY",
	three_times_a_year: "THREE_TIMES_YEARLY",
	four_times_a_year: "FOUR_TIMES_YEARLY",
	monthly: "MONTHLY_ONCE",
	two_months: "TWO_MONTHS_ONCE",
	three_months: "THREE_MONTHS_ONCE",
	four_months: "FOUR_MONTHS_ONCE",
	five_months: "FIVE_MONTHS_ONCE",
	six_months: "SIX_MONTHS_ONCE",
};

export const subscriptionFrequencies = [
	{
		id: "YEARLY",
		name: "Once a year",
		frequency: 1,
	},
	{
		id: "TWICE_YEARLY",
		name: "Twice a year",
		frequency: 2,
	},
	{
		id: "THREE_TIMES_YEARLY",
		name: "Three times a year",
		frequency: 3,
	},
	{
		id: "FOUR_TIMES_YEARLY",
		name: "Four times a year",
		frequency: 4,
	},
];

export const frequencyList = [
	{
		id: frequencyTypes.monthly,
		name: "1 month",
	},
	{
		id: frequencyTypes.two_months,
		name: "2 months",
	},
	{
		id: frequencyTypes.three_months,
		name: "3 months",
	},
	{
		id: frequencyTypes.four_months,
		name: "4 months",
	},
	{
		id: frequencyTypes.five_months,
		name: "5 months",
	},
	{
		id: frequencyTypes.six_months,
		name: "6 months",
	},
];

export const subscription = {
	frequency: frequencyTypes.yearly,
	price: "",
	bottles: "",
	subscriptionType: subscriptionTypes.wineClub,
	wineClubId: null,
	paymentMethodId: null,
	shippingAddressId: null,
	collections: [],
	subscriptionProducts: [],
	subscriptionShippingMonths: [
		{
			monthNumber: 1,
			monthName: "January",
			monthOrder: 1,
		},
	],
};

export const productSubscription = {
	...subscription,
	frequency: frequencyTypes.monthly,
	price: 0,
	subscriptionType: subscriptionTypes.product,
	subscriptionShippingMonths: [],
};

export const SubscriptionSchema = yup.object().shape({
	bottles: yup.string().required("Please enter a # bottles"),
	frequency: yup.string().required("Please select a frequency"),
});

const frequencyMapperList = [
	{
		id: "YEARLY",
		name: "Once a year",
		frequency: 1,
	},
	{
		id: "TWICE_YEARLY",
		name: "Twice a year",
		frequency: 2,
	},
	{
		id: "THREE_TIMES_YEARLY",
		name: "Three times a year",
		frequency: 3,
	},
	{
		id: "FOUR_TIMES_YEARLY",
		name: "Four times a year",
		frequency: 4,
	},
	{
		id: "MONTHLY_ONCE",
		name: "Every month",
		frequency: 11,
	},
	{
		id: "TWO_MONTHS_ONCE",
		name: "Every 2 months",
		frequency: 11,
	},
	{
		id: "THREE_MONTHS_ONCE",
		name: "Every 3 months",
		frequency: 11,
	},

	{
		id: "FOUR_MONTHS_ONCE",
		name: "Every 4 months",
		frequency: 11,
	},

	{
		id: "FIVE_MONTHS_ONCE",
		name: "Every 5 months",
		frequency: 11,
	},

	{
		id: "SIX_MONTHS_ONCE",
		name: "Every 6 months",
		frequency: 11,
	},
];

export const getFrequencyText = (frequency) => {
	const out = find(frequencyMapperList, { id: frequency });
	return out ? out.name : frequency;
};
